(() => {
  'use strict';
  if (window.HSXOfferTransport) return;
  class OfferError extends Error {
    constructor(code, uncertain = false, detail = '') {
      super(detail || code);
      this.name = 'OfferError';
      this.code = code;
      this.uncertain = uncertain;
    }
  }
  async function submit(options) {
    const item = Object.freeze({
      id: options.variantId,
      quantity: 1,
      ...(options.planId ? {selling_plan: options.planId, properties: Object.freeze({_arl_consent: String(options.consent || '')})} : {})
    });
    if (!item.id || (options.planId && !item.properties._arl_consent)) throw new OfferError('consent_required');
    const route = options.route || '/';
    if (!route.startsWith('/') || route.startsWith('//')) throw new OfferError('error');
    const base = route.endsWith('/') ? route : route + '/';
    const productUrl = new URL(options.productUrl, location.origin);
    if (productUrl.origin !== location.origin) throw new OfferError('error');
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (options.signal?.aborted) controller.abort();
    options.signal?.addEventListener('abort', abort, {once: true});
    const timer = setTimeout(abort, options.timeoutMs || 20000);
    let addSent = false, definiteRejection = false;
    const request = (url, init = {}) => fetch(url, {credentials: 'same-origin', ...init, signal: controller.signal});
    try {
      const freshResponse = await request(productUrl.pathname.replace(/\/$/, '') + '.js', {cache: 'no-store'});
      if (!freshResponse.ok) throw new OfferError('error');
      const fresh = await freshResponse.json();
      if (!options.validate(fresh)) throw new OfferError('pending');
      if (controller.signal.aborted) throw new OfferError('request_timeout');
      if (item.selling_plan) {
        const consentResponse = await request(base + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({attributes: {_arl_consent: item.properties._arl_consent}})
        });
        if (!consentResponse.ok) throw new OfferError('error');
      }
      if (controller.signal.aborted) throw new OfferError('request_timeout');
      addSent = true;
      const response = await request(base + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [item]})
      });
      if (!response.ok) {
        definiteRejection = response.status >= 400 && response.status < 500;
        let detail = '';
        try { const data = await response.json(); if (typeof data.description === 'string') detail = data.description; } catch {}
        throw new OfferError('error', !definiteRejection, detail);
      }
      const result = await response.json();
      if (Number(result?.status) >= 400) throw new OfferError('error', false);
      if (!Array.isArray(result?.items) || !result.items.length) throw new OfferError('error', true);
      return {result, cartPath: base + 'cart'};
    } catch (error) {
      if (error instanceof OfferError) throw error;
      throw new OfferError(error.name === 'AbortError' ? 'request_timeout' : 'error', addSent && !definiteRejection);
    } finally {
      clearTimeout(timer);
      options.signal?.removeEventListener('abort', abort);
    }
  }
  window.HSXOfferTransport = Object.freeze({submit, OfferError});
})();
